module.exports = __webpack_public_path__ + "img/crate6.43ab9d75.png";